import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { IChild } from 'main/gql/child'
import { Strong, Text } from 'main/ui'
import { formatDateHuman } from 'main/util/date'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../../../../i18n'

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-REVIEW-DETAILS-CHILD`

interface IProps {
  child: IChild
}

export default function ChildDetails(props: IProps) {
  const { child } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const name = child.name
  const gender = child.gender ? t(`${PRE}-${child.gender}`) : ''
  const birthday = child.birthday ? formatDateHuman(child.birthday) : ''

  return (
    <div>
      <div>
        <Strong>{t(`${PRE}-TITLE`)}</Strong>
        <Text>{t(`${PRE}-TEXT`, { name, gender, birthday })}</Text>
      </div>

      {child.desiredEnrollmentDate && (
        <div>
          <Strong>{t(`${PRE}-DATE`)}</Strong>
          <Text>{formatDateHuman(child.desiredEnrollmentDate)}</Text>
        </div>
      )}
    </div>
  )
}
